import React, { useState, useEffect } from 'react';
import './snowflakes.css';

const Snowflakes = () => {
  const [showSnow, setShowSnow] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDate = () => {
      const today = new Date();
      const currentMonth = today.getMonth() + 1; // 1-12 (January = 1, December = 12)
      const currentDay = today.getDate();

      // December 20 to December 31 - sneg pada od 20. decembra
      const isDecemberPeriod = currentMonth === 12 && currentDay >= 20;
      
      // January 1 to January 19 - sneg pada do 19. januara (uključivo), isključuje se 20. januara
      const isJanuaryPeriod = currentMonth === 1 && currentDay < 20;

      // Show snow if we're in the holiday period (Dec 20 - Jan 19, isključuje se 20. januara)
      setShowSnow(isDecemberPeriod || isJanuaryPeriod);
    };

    const checkMobile = () => {
      // Mobile detection based on screen width only
      setIsMobile(window.innerWidth <= 768);
    };

    checkDate();
    checkMobile();
    
    // Check once per day to handle date changes
    const interval = setInterval(checkDate, 3600000); // Check every hour
    
    // Check for mobile on resize
    window.addEventListener('resize', checkMobile);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Generate multiple snowflakes with random properties
  // Fewer flakes on mobile for better performance
  const flakeCount = isMobile ? 20 : 50;
  const snowflakes = Array.from({ length: flakeCount }, (_, i) => ({
    id: i,
    size: isMobile ? (Math.random() * 1.5 + 0.75) : (Math.random() * 2 + 1), // Mobile: 0.75-2.25px (50% veće), Desktop: 1-3px
    left: Math.random() * 100, // 0-100%
    animationDuration: isMobile ? (Math.random() * 40 + 40) : (Math.random() * 30 + 30), // Mobile: 40-80s (još sporije), Desktop: 30-60s
    animationDelay: Math.random() * 10, // 0-10s
    opacity: Math.random() * 0.15 + 0.05, // 0.05-0.2 (nežnije)
  }));

  // Only render snowflakes if we're in the holiday period
  if (!showSnow) {
    return null;
  }

  return (
    <div className="snowflakes-container">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            left: `${flake.left}%`,
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            animationDuration: `${flake.animationDuration}s`,
            animationDelay: `${flake.animationDelay}s`,
            opacity: flake.opacity,
          }}
        >
          ❄
        </div>
      ))}
    </div>
  );
};

export default Snowflakes;

